import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {delay, filter, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {Router} from "@angular/router";
import {NewsletterService} from "../../../shared/services/newsletter.service";
import {Document} from "../../../shared/interface/document";
import {Newsletter} from "../../../shared/interface/newsletter";
import {Observable, of, ReplaySubject} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {FileInput, FileValidator} from "ngx-material-file-input";
import {FileBase64} from "../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";
import {Template} from "../../../shared/interface/template";
import {Dictionary} from "../../../shared/interface/dictionary";

@Component({
  selector: 'app-newsletter-add',
  templateUrl: './newsletter-add.component.html',
  styleUrls: ['./newsletter-add.component.scss']
})
export class NewsletterAddComponent implements OnInit {

  @Input() newsletter?: Observable<Newsletter>;
  @Input() dialogRef?: MatDialogRef<DocumentAddDialogComponent>;


  @Input() disableBreadcrumb = false;
  @Output() newsletterCreated = new EventEmitter<string>();
  @Output() closeModification = new EventEmitter<any>();


  fileMaxSize = 7340032 * 5;
  documentForm: FormGroup;
  fileControl: FormControl;
  fileContentControl: FormControl;
  fileNameControl: FormControl;
  contentControl: FormControl;
  newsletterNameControl: FormControl;
  processingRequest = false;
  formErrors = {};
  newsletterObject?: Newsletter;
  newsletterFormValid = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
    private newsletterService: NewsletterService
  ) {
    this.documentForm = fb.group({
      // file: this.fileControl = fb.control(''),
      name: fb.control(''),
      fileName: this.fileNameControl = fb.control(''),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      newsletterName: this.newsletterNameControl = fb.control('', [Validators.required]),

    });
    // this.documentForm.get('fileName').disable();
  }

  cancel(): void {
    if (this.newsletter) {
      this.closeModification.emit();
    } else {
      this.router.navigate(['/newsletter/historia']);
    }
  }
  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }

  ngOnInit(): void {
    this.documentForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.newsletterFormValid = this.documentForm.valid);

    if (this.newsletter) {
      this.newsletter
        .pipe(takeUntil(this.destroyed$))
        .subscribe((newsletter: Newsletter) => {
          this.initialize(newsletter);
          this.newsletterObject = newsletter;
        });
      // this.documentForm.get('file').setValidators([Validators.required, FileValidator.maxContentSize(this.fileMaxSize)]);
      }
  }
  initialize(newsletter: Newsletter): void {
    of(newsletter)
      .pipe(
        delay(0),
        tap(() => {
          // this.fileContentControl.setValidators([]);

          this.documentForm.reset({
            newsletterName: newsletter.newsletterName,
            name: newsletter.fileName,
            // fileName: newsletter.fileName
          });
        }),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  save(): void {

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.documentForm, this.formErrors);
    this.formErrors = {};

    this.newsletterService.sendForm(this.documentForm.getRawValue(), this.newsletterObject?.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.newsletterObject ? 'Pomyślnie zaktualizowano Newsletter'
          : 'Pomyślnie dodano dokument', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.newsletter) {
          this.closeModification.emit(response.uuid);
          location.reload();
        } else {
          this.router.navigate(['/newsletter/']);
        }

      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open(this.newsletterObject ? 'Podczas aktualizacji Newslettera wystąpił błąd'
          : 'Podczas wgrywania dokumentu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.documentForm, this.formErrors);
        }
      })
    ;
  }

}
